<template>
    <v-container class="fluid" style="background-color: rgb(255, 251, 246); font-family: Open Sans, sans-serif">
        <div class="main" v-responsive.lg.xl v-if="isValidToken">
            <p class="sign" align="center">Définissez votre mot de passe</p>
            <form class="form1">
                <!-- Mot de passe -->
                <div class="input-wrapper">
                    <input :type="showPassword ? 'text' : 'password'" class="un"  v-model="password_new"   placeholder="Mot de passe" />
                    <span class="eye-icon ml-2" @click="togglePasswordVisibility">
                        <i v-if="showPassword" class="fa fa-eye-slash"></i>
                        <i v-else class="fa fa-eye "></i>
                    </span>
                </div>
                <!-- Confirmation -->
                <div class="input-wrapper">
                    <input  :type="showConfirmation ? 'text' : 'password'" class="pass" v-model="confirmation" placeholder="Confirmation de mot de passe" />
                    <span class="eye-icon ml-2" @click="toggleConfirmationVisibility">
                        <i v-if="showConfirmation" class="fa fa-eye-slash"></i>
                        <i v-else class="fa fa-eye"></i>
                    </span>
                </div>
                <a @click="setChangedPassword" class="submit">Valider</a>
            </form>
        </div>

        <div class="main-mobile" v-responsive.sm.xs v-if="isValidToken">
            <p class="sign-mobile" align="center">Changement de mot de passe</p>
            <form class="form1-mobile">
                <input class="un-mobile" v-model="password_new" type="password" placeholder="Mot de passe">
                <input class="pass-mobile" v-model="confirmation" type="password" placeholder="Confirmation de mot de passe">
                <a @click="setChangedPassword" class="submit-mobile">Valider</a>
            </form>           
        </div>

        <div v-if="!isValidToken" style="margin-top: 120px;margin-bottom: 100px;">
            <p class="sign" style="font-weight: 500;color: #2b2b2b;" align="center">Le lien que vous avez utilisé n'est plus valide.</p>
            <p align="center"> <a @click="newPasswordMailRequest = true" style="color: #ffa409;font-weight: 400;" href="javascript:void(0)">Demander un nouveau lien</a></p>
        </div>

         <!--======================= request new mail password ======================= -->
        <v-dialog v-model="newPasswordMailRequest" persistent max-width="600px">
            <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
                <div role="tabpanel" id="change_password" aria-hidden="true" aria-labelledby="step-change_password" class="wizard-tab-container">
                <div>
                    <div class="loan-group loan-group-0">
                    <div class="fields">
                        <div class="field-title font-weight-bold">Demande de nouveau lien&nbsp;:</div>
                        <div class="row">
                        <div class="col-sm-12">
                            <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="adresse_mail" class="field-label">
                                Adresse e-mail
                                <!---->
                            </label>
                            <div class="input-group value-loan">
                                <input type="text" v-model="user_requester_email" placeholder="Saisir votre adresse email" id="adresse_mail"  name="adresse_mail" class="field-input">
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                <button @click="newPasswordMailRequest = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('devis.devis_auto.bouton_retour') }}
                </button>
                </div>
                <div class="wizard-footer-right">
                <button @click="ask_new_link()" type="button" class="wizard-btn">
                    {{ $t('devis.devis_auto.bouton_valider') }}
                </button>
                </div>
                <!---->
            </div>
            </v-card-text>
            </v-card>
        </v-dialog>
        <!--======================= Fin request new mail password ============================== -->
    </v-container>
</template>

<script>
import Api from '../../services/Api'
    export default {
        name: "set_password",
        data() {
            return {
                newPasswordMailRequest : null,
                user_requester_email: null,
                email: null,
                isValidToken: false,
                showPassword: false,
                showConfirmation: false,
                tokenUserData: null,
                notifications: false,
                password_new: null,
                confirmation: null,
                ToastTabSucess: {
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 5000,
                    fitToScreen: true,
                    type: 'success',
                    className: 'custom-success-class'
                }, // Customized options for success toast
                ToastTabError: {
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 5000,
                    fitToScreen: true,
                    type: 'error'
                },// Customized options for error toast
                email: null,
                ServerRep: null,
            }
        },
        methods: {
        //     async valid_new_password_mail_request (){
        //     this.errors = {}
        //     const validEmail = validateEmail(this.user_requester_email);
        //     this.errors.email = validEmail.error;
        //         if (validEmail.valid == true) {
        //             await this.ask_new_link()
        //         }
        // },
            ask_new_link() {
                if (this.user_requester_email) {
                    let userData = { "email": this.user_requester_email, tokens: this.tokenUserData }
                    Api().post('user/auth/ask-new-link', userData)
                        .then(response => {
                            this.$toasted.show('Un nouveau lien a été envoyé à votre adresse e-mail.', this.ToastTabSucess);
                            setTimeout(() => {
                                this.newPasswordMailRequest = false;
                                this.$router.push('/');
                            }, 2000);
                        }).catch(error => {
                            if (error.response && error.response.data && error.response.data.message) {
                                this.$toasted.show(error.response.data.message, this.ToastTabError);
                            } else {
                                this.$toasted.show('Une erreur est survenue lors de l\'envoi du lien', this.ToastTabError);
                            }
                        });
                } else {
                    this.$toasted.show('Veuillez entrer votre adresse e-mail', this.ToastTabError);
                }
            },
            togglePasswordVisibility() {
                this.showPassword = !this.showPassword;
            },
            toggleConfirmationVisibility() {
                this.showConfirmation = !this.showConfirmation;
            },

            checklink_to_set_user_password(token) {
                if (token) 
                {
                    let userData = { "token": token  }
                    Api().post('user/checklink/set-password', userData)
                    .then(response => {
                        if(response.data && response.data.ok===0) {
                            this.$toasted.show('Lien invalide ou expiré.', this.ToastTabError)
                        }else {
                            this.isValidToken = true;
                        } 
                    }).catch(error => {
                        if (error.response && error.response.data && error.response.data.msg) {
                            this.$toasted.show(error.response.data.msg, this.ToastTabError);
                            this.isValidToken = false;
                        } else {
                            this.$toasted.show('Une erreur est survenue lors de la vérification du token', this.ToastTabError);
                        }
                    });
                } else {
                    this.$toasted.show('Le token est manquant', this.ToastTabError);
                }
            },

            isPasswordStrong(password) {
                const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{15,}$/;
                return strongPasswordRegex.test(password);
            },

            async setChangedPassword() {
                if (this.password_new && this.confirmation) {
                    if (this.confirmation === this.password_new) {
                        if(this.password_new.length >= 15 && this.confirmation.length >= 15 && this.isPasswordStrong(this.password_new)) {
                            let userData = {
                                "token" : this.tokenUserData,
                                "password" : this.password_new,
                                "password_confirmation" :  this.confirmation
                            }
                            await Api().post('user/auth/set-password', userData).then(response => {
                            this.$toasted.show('Mot de passe modifié avec succès', this.ToastTabSucess);
                            setTimeout(() => {  this.$router.push('/')  }, 3000);
                            }).catch(error => {
                                if( error.response && error.response.data && error.response.data.message) {
                                    this.$toasted.show(error.response.data.message, this.ToastTabError);
                                } else {
                                    this.$toasted.show('Une erreur est survenue lors de la modification du mot de passe', this.ToastTabError);
                                }
                            });
                        }else{
                            this.$toasted.show("Choisissez un mot de passe sécurisé : 15 caractères minimum, avec une majuscule, un chiffre et un symbole", this.ToastTabError)
                        }
                    } else {
                        this.$toasted.show('Vos deux mots de passe ne sont pas identiques', this.ToastTabError)
                    }
                } else {
                    this.$toasted.show('le mot de passe et la confirmation sont obligatoires', this.ToastTabError)
                }
            },

        },

        mounted() 
        {
            window.scrollTo(0, 0);
            const params = new URLSearchParams(window.location.search);
            this.tokenUserData = params.get('usertoken').replace(/[_]/g, '/')
            this.checklink_to_set_user_password(this.tokenUserData)
        },
    }
</script>

<style lang="less" scoped>
@import "../../assets/css/button.css";
@import "../../assets/css/devis_css.css";

.show_or_hide_password {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer; 
    z-index: 10;
}

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-size: 15px;
}
    .list-boutons .link-btn {
        text-decoration: none;
    }

    .list-boutons li {
        list-style: none;
    }

    .list-boutons .link-btn:hover {
        background: #ffa409;
        color: white;
    }








    .main {
        background-color: #FFFFFF;
        width: 500px;
        height: 350px;
        margin: 7em auto;
        border-radius: 1.5em;
        box-shadow: 0px 11px 35px 2px rgba(0, 0, 0, 0.14);
    }
    
    .sign {
        padding-top: 40px;
        color: #ffa409;
        font-family: 'Ubuntu', sans-serif;
        font-weight: bold;
        font-size: 23px;
    }
    
    .un {
    width: 80%;
    color: rgb(38, 50, 56);
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 1px;
    background: rgba(136, 126, 126, 0.04);
    padding: 10px 20px;
    border: none;
    border-radius: 20px;
    outline: none;
    box-sizing: border-box;
    border: 2px solid rgba(0, 0, 0, 0.02);
    margin-bottom: 50px;
    margin-left: 46px;
    text-align: center;
    margin-bottom: 27px;
    font-family: 'Ubuntu', sans-serif;
    }
    
    form.form1 {
        padding-top: 40px;
    }
    
    .pass {
            width: 80%;
    color: rgb(38, 50, 56);
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 1px;
    background: rgba(136, 126, 126, 0.04);
    padding: 10px 20px;
    border: none;
    border-radius: 20px;
    outline: none;
    box-sizing: border-box;
    border: 2px solid rgba(0, 0, 0, 0.02);
    margin-bottom: 50px;
    margin-left: 46px;
    text-align: center;
    margin-bottom: 27px;
    font-family: 'Ubuntu', sans-serif;
    }
    
   
    .un:focus, .pass:focus {
        border: 2px solid rgba(0, 0, 0, 0.18) !important;
        
    }
    
    .submit {
      cursor: pointer;
        border-radius: 5em;
        color: #fff;
        background: #ffa409;
        border: 0;
        padding-left: 40px;
        padding-right: 40px;
        padding-bottom: 10px;
        padding-top: 10px;
        //font-family: 'Ubuntu', sans-serif;
        margin-left: 38%;
        font-size: 15px;
        box-shadow: 0 0 20px 1px rgba(0, 0, 0, 0.04);
    }
    
    .forgot {
        text-shadow: 0px 0px 3px rgba(117, 117, 117, 0.12);
        color: #E1BEE7;
        padding-top: 15px;
    }
    
    // a {
    //     text-shadow: 0px 0px 3px rgba(117, 117, 117, 0.12);
    //     color: #E1BEE7;
    //     text-decoration: none
    // }
    
    @media (max-width: 600px) {
        .main {
            border-radius: 0px;
        }
    }

























    .main-mobile {
        background-color: #FFFFFF;
        width: auto;
        height: 350px;
        margin: 12em auto;
        border-radius: 1.5em;
        box-shadow: 0px 11px 35px 2px rgba(0, 0, 0, 0.14);
        //margin-top: 20px;
    }
    
    .sign-mobile {
        padding-top: 40px;
        color: #ffa409;
        font-family: 'Ubuntu', sans-serif;
        font-weight: bold;
        font-size: 23px;
    }
    
    .un-mobile {
    width: 80%;
    color: rgb(38, 50, 56);
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 1px;
    background: rgba(136, 126, 126, 0.04);
    padding: 10px 20px;
    border: none;
    border-radius: 20px;
    outline: none;
    box-sizing: border-box;
    border: 2px solid rgba(0, 0, 0, 0.02);
    margin-bottom: 50px;
    margin-left: 46px;
    text-align: center;
    margin-bottom: 27px;
    font-family: 'Ubuntu', sans-serif;
    }
    
    form.form1-mobile {
        padding-top: 40px;
    }
    
    .pass-mobile {
            width: 80%;
    color: rgb(38, 50, 56);
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 1px;
    background: rgba(136, 126, 126, 0.04);
    padding: 10px 20px;
    border: none;
    border-radius: 20px;
    outline: none;
    box-sizing: border-box;
    border: 2px solid rgba(0, 0, 0, 0.02);
    margin-bottom: 50px;
    margin-left: 46px;
    text-align: center;
    margin-bottom: 27px;
    font-family: 'Ubuntu', sans-serif;
    }
    
   
    .un-mobile:focus, .pass-mobile:focus {
        border: 2px solid rgba(0, 0, 0, 0.18) !important;
        
    }
    
    .submit-mobile {
      cursor: pointer;
        border-radius: 5em;
        color: #fff;
        background: #ffa409;
        border: 0;
        padding-left: 40px;
        padding-right: 40px;
        padding-bottom: 10px;
        padding-top: 10px;
        //font-family: 'Ubuntu', sans-serif;
        margin-left: 35%;
        align-items: center;
        font-size: 15px;
        box-shadow: 0 0 20px 1px rgba(0, 0, 0, 0.04);
    }
    
    
    // a {
    //     text-shadow: 0px 0px 3px rgba(117, 117, 117, 0.12);
    //     color: #E1BEE7;
    //     text-decoration: none
    // }
    
    @media (max-width: 600px) {
        .main {
            border-radius: 0px;
        }
    }
        

</style>